import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';

import { CarriersActions } from '../actions';
import { Carrier, CarrierTypes } from '@app/services/carriers/carrier.model';
import { Shop } from '@app/services/shops/shop.model';

export const featureKey = 'сarriers';

export interface CarriersState {
  shopsList: Shop[];
  carrierTypes: CarrierTypes[];
  carriers: Carrier[];
  pendingEditCarrier: boolean;
  errorMessageEditCarrier: string;
  pendingAddCarrier: boolean;
  errorMessageAddCarrier: string;
  errorMessageDeleteCarrier: string;
}

export const initialState: CarriersState = {
  shopsList: null,
  carrierTypes: null,
  carriers: null,
  pendingEditCarrier: false,
  errorMessageEditCarrier: null,
  pendingAddCarrier: false,
  errorMessageAddCarrier: null,
  errorMessageDeleteCarrier: null,
};

export const reducer = createReducer(
  initialState,
  on(CarriersActions.loadShopsUserSuccess, (state, { shopsList }) => ({
    ...state,
    shopsList,
  })),
  on(CarriersActions.loadAllCarrierTypesSuccess, (state, { carrierTypes }) => ({
    ...state,
    carrierTypes,
  })),
  on(CarriersActions.loadCarriersByShopSuccess, (state, { carriers }) => ({
    ...state,
    carriers,
  })),
  on(CarriersActions.addNewCarrier, (state, payload) => ({
    ...state,
    pendingAddCarrier: true,
    errorMessageAddCarrier: null,
  })),
  on(CarriersActions.addNewCarrierSuccess, (state, { carrier }) => ({
    ...state,
    createdCarrier: carrier,
    pendingAddCarrier: false,
  })),
  on(CarriersActions.addNewCarrierFailure, (state, { errorMessage }) => ({
    ...state,
    pendingAddCarrier: false,
    errorMessageAddCarrier: errorMessage,
  })),
  on(CarriersActions.editCarrier, (state, payload) => ({
    ...state,
    pendingEditCarrier: true,
    errorMessageEditCarrier: null,
  })),
  on(CarriersActions.editCarrierSuccess, (state, { carrier }) => ({
    ...state,
    editedCarrier: carrier,
    carriers: state.carriers.map((item: Carrier) => (item.id === carrier.id ? carrier : item)),
    pendingEditCarrier: false,
  })),
  on(CarriersActions.editCarrierFailure, (state, { errorMessage }) => ({
    ...state,
    pendingEditCarrier: false,
    errorMessageEditCarrier: errorMessage,
  })),

  on(CarriersActions.deleteCarrierSuccess, (state, { carrierId }) => ({
    ...state,
    carriers: state.carriers.filter((carrier: Carrier) => carrier.id !== carrierId),
  })),
  on(CarriersActions.deleteCarrierFailure, (state, { errorMessage }) => ({
    ...state,
    errorMessageDeleteCarrier: errorMessage,
  })),
);

export interface State {
  [featureKey]: CarriersState;
}

// export function reducers(state: State, action: Action): State {
//   return combineReducers({
//     [featureKey]: reducer,
//   })(state, action);
// }

export const selectCarriersState = createFeatureSelector<State, CarriersState>(featureKey);

export const selectShopsList = createSelector(selectCarriersState, (state: CarriersState) => state.shopsList);
export const selectCarrierTypes = createSelector(selectCarriersState, (state: CarriersState) => state.carrierTypes);
export const selectCarriers = createSelector(selectCarriersState, (state: CarriersState) => state.carriers);
export const selectPendingEditCarrier = createSelector(
  selectCarriersState,
  (state: CarriersState) => state.pendingEditCarrier,
);
export const selectPendingAddCarrier = createSelector(
  selectCarriersState,
  (state: CarriersState) => state.pendingAddCarrier,
);
export const selectErrorMessageEditCarrier = createSelector(
  selectCarriersState,
  (state: CarriersState) => state.errorMessageEditCarrier,
);
export const selectErrorMessageAddCarrier = createSelector(
  selectCarriersState,
  (state: CarriersState) => state.errorMessageAddCarrier,
);

export const selectErrorMessageDeleteCarrier = createSelector(
  selectCarriersState,
  (state: CarriersState) => state.errorMessageDeleteCarrier,
);
